import React from 'react'
import styles from './progress-indicator.module.css'

export default function ProgressIndicator({ currentStep = 0, totalSteps = 7 }) {
  return (
    <div className={styles.progressBarWrapper}>
      <div className={styles.progressBar}>
        {Array.from({ length: totalSteps }).map((_, index) => (
          <div
            key={index}
            className={
              `${styles.progressSegment} ` +
              (index < currentStep
                ? styles.completed
                : index === currentStep
                  ? styles.active
                  : styles.inactive)
            }
          />
        ))}
      </div>
    </div>
  )
}
